import { getUA } from '@kso/util'
export const ua = getUA(window.navigator.userAgent)
const isWechat = ua.weixin && !ua.wxminiprogram
const THIRD_PREFIX = '/3rd/plus'
// 微信内嵌、QQ内嵌或者钉钉下载
export const isSpecialFrame = isWechat || ua.qq || ua.dingtalk
// 是否鸿蒙系统
export const isOhOs = /(?:harmony|ohos)/i.test(window.navigator.userAgent)

const agent = window.navigator.userAgent.toLowerCase()
export const isWpsOfficeApp = /WpsOfficeApp/i.test(agent)

// 针对特殊场景，增加baseUrl配置
export const getCurrentPrefix = () => {
  const firstPrefix =  window.location.pathname.startsWith(THIRD_PREFIX) ? THIRD_PREFIX : ''
  return firstPrefix + process.env.VUE_APP_BASE_URL
}

// 如果使用🌞d/plus 请求，则请求前缀也改为与目标域名一致
export const formatApiRequestBaseUrl = (url) => {
  const requestPath = url.split('plus.wps.cn/')[1]
  return window.location.pathname.startsWith(THIRD_PREFIX) ? `${window.location.origin}${THIRD_PREFIX}/${requestPath}` : url
}
